import { render, staticRenderFns } from "./ModuleMenu.vue?vue&type=template&id=62a39e92&scoped=true&"
import script from "./ModuleMenu.vue?vue&type=script&lang=js&"
export * from "./ModuleMenu.vue?vue&type=script&lang=js&"
import style0 from "./ModuleMenu.vue?vue&type=style&index=0&id=62a39e92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a39e92",
  null
  
)

export default component.exports